export const transactionTrackIDs = {
    search: {
        id: 'dagligbank-transaction-search',
    },
};
